import React, { useContext } from 'react';
import { IconChevronRight } from '@prisjakt/ui/icon';
import { AppContext } from '@prisjakt/ui-app-context';
import { ButtonIcon, ButtonText } from '@prisjakt/ui/button';
import { useCtaCopyFiExperiment } from 'src/hooks/experiments';
import { StoreLink, LinkDesktop, LinkMobile } from './styles';

export const GoToStoreButton: React.FC = () => {
  const { t } = useContext(AppContext);
  const newCtaCopyFi = useCtaCopyFiExperiment();

  // Experiment is only running on FI market.
  const title = newCtaCopyFi ? 'Katso tuotetta' : t('product', 'store.link');

  return (
    <StoreLink data-test="GoToStoreButton">
      <LinkDesktop ariaLabel={title} tabIndex={-1}>
        <ButtonText>{title}</ButtonText>
        <ButtonIcon>
          <IconChevronRight />
        </ButtonIcon>
      </LinkDesktop>
      <LinkMobile>
        <IconChevronRight color="maybeBlue500" size={24} />
      </LinkMobile>
    </StoreLink>
  );
};
